import { Network, NetworkEvents } from "@/frameworks/libraries";
import { BehaviorSubject } from "rxjs";

/**
 * 네트워크의 상태를 관찰하고 이벤트를 발생시키는 클래스
 */
class WSNetworkServiceObserver {
	private _status$: BehaviorSubject<"idle" | "pending" | "fullfiled" | "rejected"> = new BehaviorSubject<
		"idle" | "pending" | "fullfiled" | "rejected"
	>("idle");
	private static _instance: WSNetworkServiceObserver | null = null;
	public static getInstance(): WSNetworkServiceObserver {
		return this._instance || (this._instance = new this());
	}
	constructor() {
		this._addEvents();
	}

	public get status$() {
		return this._status$;
	}

	private _addEvents() {
		console.log(this.constructor.name, "addEvents", Network);
		Network.instances["default"].on(NetworkEvents.onConnected, () => {
			this._status$.next("fullfiled");
		});
		Network.instances["default"].on(NetworkEvents.onConnectFailure, () => {
			this._status$.next("rejected");
		});
		Network.instances["default"].on(NetworkEvents.onStompError, () => {
			this._status$.next("rejected");
		});
		Network.instances["default"].on(NetworkEvents.onDisconnect, () => {
			this._status$.next("idle");
		});
		Network.instances["default"].on(NetworkEvents.onWebSocketClosed, () => {
			this._status$.next("idle");
		});
	}
}

export default WSNetworkServiceObserver;
